import { render, staticRenderFns } from "./ManageDialog.vue?vue&type=template&id=cd2c526c&scoped=true&"
import script from "./ManageDialog.vue?vue&type=script&lang=js&"
export * from "./ManageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManageDialog.vue?vue&type=style&index=0&id=cd2c526c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c526c",
  null
  
)

export default component.exports